'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.waitForImage = exports.isShadyDOM = exports.isElement = exports.nodeIsElement = exports.nodeIsText = void 0;
function nodeIsText(node) {
    return node.nodeType === Node.TEXT_NODE;
}
exports.nodeIsText = nodeIsText;
function nodeIsElement(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
exports.nodeIsElement = nodeIsElement;
/**
 * Determines if the passed object is a HTML Element.
 * @param object any JS object
 */
function isElement(object) {
    return object instanceof Element;
}
exports.isElement = isElement;
function isShadyDOM() {
    return !!window.ShadyDOM;
}
exports.isShadyDOM = isShadyDOM;
/**
 * Returns a promise resolved when image is either loaded or broken
 */
function waitForImage(image) {
    return new Promise(function (resolve) {
        if (!image) {
            return resolve();
        }
        if (image.complete && image.naturalHeight !== 0) {
            return resolve();
        }
        image.onload = function () {
            resolve();
        };
        image.onerror = function () {
            resolve();
        };
        image.onabort = function () {
            resolve();
        };
    });
}
exports.waitForImage = waitForImage;
